import styled from 'styled-components';

import { cellWidth } from '../Permissions/utils/constants';

const HiddenAction = styled.div`
  width: ${cellWidth};
`;

export default HiddenAction;
